// import React from 'react';
// import './FrontPages.css';
// import backgroundImage from '../../Assets/BackgroundImage4.png';


// function FrontPage() {
//   return (
    

//     <div className="front-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
//       <div className="content">
//         <h1 className="title">Welcome to University Research </h1>
//         <p className="subtitle">Explore and discover amazing features!</p>
//         <div className="button-container">
//           <button className="btn primary">Research Grants</button>
//           <button className="btn secondary">Awards</button>
//         </div>
//       </div>
//     </div>
    
//   );
// }

// export default FrontPage;

import React from 'react';
import { useNavigate } from 'react-router-dom'; // make sure react-router-dom is installed
import './FrontPages.css';
import backgroundImage from '../../Assets/BackgroundImage4.png';
import uniLogo from '../../Assets/logo2.png';

function FrontPage() {
  const navigate = useNavigate();

  const goToResearch = () => {
    navigate('/home'); // same app
  };

  const goToAwards = () => {
    window.location.href = 'https://rgms.pdn.ac.lk/AMS'; // external system (new URL)
  };

  return (
    <div className="front-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="content">
        <img src={uniLogo} alt="University Logo" className="uni-logo" />
        <h1 className="fronttittle">WELCOME TO UNIVERSITY RESEARCH & AWARDS</h1>
        <p className="subtitle">Empowering Innovation and Achievement</p>
        <div className="button-container">
          <button className="researchbtn" onClick={goToResearch}>Research Grants</button>
          <button className="awardbtn" onClick={goToAwards}>Awards</button>
        </div>
      </div>
    </div>
  );
}

export default FrontPage;
